export default defineNuxtRouteMiddleware((to) => {
    const jsessionid = useCookie('JSESSIONID')

    if (!jsessionid.value && to.path != '/login' && !to.path.includes('/api')) {
        console.log('dashboard-auth.global: Redirecting to login - no JSESSIONID')
        return navigateTo(`/login${to.path != '/' ? '?redirect_uri=' + encodeURIComponent(to.path + to.fullPath.substring(to.path.length)) : ''}`)
    }
})
